import {Component, OnInit} from '@angular/core';
import {ApiService} from '../../../services/api.service';
import {LoginService} from '../../../services/login.service';
import {ActivatedRoute} from '@angular/router';
import {NotificationsService} from 'angular2-notifications';
import {ModalService} from '../../../services/modalService/modal.service';
import {DenialComponent} from '../zoomView/denial/denial.component';
import {ModalHelper} from '../../../services/modalService/modal.helper';
import {GoogleAnalyticsService} from "../../../services/google-analytics-service";
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-denials',
  templateUrl: './denials.component.html',
  styleUrls: ['./denials.component.css', '../myreports.component.css']
})
export class DenialsComponent implements OnInit {

  ruid: string;
  denials;
  totalDenials = 0;
  isLicense: string;
  isLoggedIn = false;
  currentUser: any;
  count = 0;

  constructor(private apiService: ApiService,
              private route: ActivatedRoute,
              private ga: GoogleAnalyticsService,
              private loginService: LoginService,
              private notifications: NotificationsService,
              private modalHelper: ModalHelper,
              private modalService: ModalService,
              private translate: TranslateService) { }

  ngOnInit() {
    this.loginService.isLoggedIn()
      .subscribe((isLoggedIn) => {
          this.currentUser = isLoggedIn;
          this.isLoggedIn = this.currentUser.isLoggedIn;
      });

    this.route.queryParams.subscribe(params => {
      if (params.ruid) {
        this.ruid = params.ruid;
        this.apiService.getSummary(this.ruid)
          .subscribe((res) => {
            this.isLicense = res.isLicense;
            if (!res.isLicense) {
              this.apiService.getDenials(this.ruid)
                .subscribe((denialsRes) => {
                  // console.log(denialsRes);
                  this.totalDenials = denialsRes.denialsTotal;
                  this.count = denialsRes.denialsNr;
                  this.denials = denialsRes.denialsByDay;
                }, (denialsErr) => {
                    this.notifications.error(this.translate.instant('common.error'), this.apiService.getMessageFromError(denialsErr, this.translate.instant('reports.denails.error')));
                });
            }
          }, (error) => {
              this.notifications.error(this.translate.instant('common.error'), this.apiService.getMessageFromError(error, this.translate.instant('reports.denails.invalidRuid')));
          });
      }
    });
  }

  downloadCSV(xls) {
    this.ga.emitEvent('Reports Actions', 'Download CSV Report', 'Click');
    this.apiService.getCSV(this.ruid, 'DENIALS', xls);
  }

  loginPrompt() {
    this.modalHelper.openLogin({});
  }

  zoomView() {
      if (this.totalDenials === 0) {
          return;
      }

    this.modalService.open(DenialComponent, {
      title: 'Denials',
      data: {
        totalDenials: this.totalDenials,
        count: this.count,
        denials: this.denials,
        currentUser: this.currentUser
      }
    }).subscribe(model => {
    });
  }
}



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/reports/myReports/denials/denials.component.ts